var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, keyframes } from 'styled-components';
import "../../enums/accordion.js";
import "../../enums/alert.js";
import "../../enums/avatar.js";
import "../../enums/breakpoints.js";
import { ButtonLooks } from "../../enums/button.js";
import "../../enums/code-editor.js";
import "../../enums/colors.js";
import "../../enums/combobox.js";
import "../../enums/date.js";
import "../../enums/drag-and-drop.js";
import "../../enums/dialog.js";
import "../../enums/divider.js";
import "../../enums/dropdown.js";
import "../../enums/fieldset.js";
import "../../enums/font-icon.js";
import "../../enums/fonts.js";
import "../../enums/headings.js";
import "../../enums/input.js";
import "../../enums/keys.js";
import "../../enums/list.js";
import "../../enums/listbox.js";
import { LoaderLabelPositions, LoaderSizes } from "../../enums/loader.js";
import "../../enums/margin.js";
import "../../enums/option.js";
import "../../enums/pill.js";
import "../../enums/placements.js";
import "../../enums/popout.js";
import "../../enums/privacy.js";
import "../../enums/radio-group.js";
import "../../enums/status.js";
import "../../enums/switch.js";
import "../../enums/table.js";
import "../../enums/tooltip.js";
import "../../enums/transitions.js";
import "../../enums/widths.js";

/**
 * Get Styled Component loader position flex direction
 * @param options GetLoaderPositionOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getLoaderPosition = function getLoaderPosition(options) {
  var labelPosition = options.labelPosition,
    size = options.size;
  var isBottom = labelPosition === LoaderLabelPositions.Bottom;
  var labelMargin = size === LoaderSizes.Large ? '15px' : size === LoaderSizes.Small ? '7px' : '10px';
  var margin = isBottom ? css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        .bf-loader__label {\n          margin-block-start: ", ";\n        }\n      "])), labelMargin) : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        .bf-loader__label {\n          margin-inline-start: ", ";\n        }\n      "])), labelMargin);
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-direction: ", ";\n    ", "\n  "])), function () {
    return isBottom ? 'column' : 'row';
  }, margin);
};
/**
 * Get Styled Component loader position flex direction
 * @param options GetLoaderSizeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getLoaderSize = function getLoaderSize(options) {
  var size = options.size;
  switch (size) {
    case LoaderSizes.Large:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        .bf-loader__label {\n          font-size: 22px;\n          line-height: 28px;\n        }\n\n        .bf-loader__svg {\n          height: 60px;\n          width: 60px;\n        }\n      "])));
      }
    case LoaderSizes.Small:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        .bf-loader__label {\n          font-size: 14px;\n          line-height: 18px;\n        }\n\n        .bf-loader__svg {\n          height: 20px;\n          width: 20px;\n        }\n      "])));
      }
    default:
      {
        // LoaderSizes.Medium
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        .bf-loader__label {\n          font-size: 18px;\n          line-height: 24px;\n        }\n\n        .bf-loader__svg {\n          height: 40px;\n          width: 40px;\n        }\n      "])));
      }
  }
};
/**
 * Get Styled Component loader theme
 * @param options GetLoaderThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getLoaderTheme = function getLoaderTheme(options) {
  var buttonLook = options.buttonLook,
    look = options.look;
  var stroke = buttonLook === ButtonLooks.Secondary || buttonLook === ButtonLooks.Tertiary || buttonLook === ButtonLooks.Warning ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          .bf-button__icon--", ":hover &,\n          .bf-button__standard--", ":hover & {\n            .bf-loader__svg-circle {\n              stroke: ", ";\n            }\n          }\n\n          .bf-button__icon--", ":active &,\n          .bf-button__standard--", ":active & {\n            .bf-loader__svg-circle {\n              stroke: ", ";\n            }\n          }\n\n          .bf-button__icon--", ":focus-visible &,\n          .bf-button__standard--", ":focus-visible & {\n            .bf-loader__svg-circle {\n              stroke: ", ";\n            }\n          }\n        "])), buttonLook, buttonLook, function (_ref) {
    var theme = _ref.theme;
    return theme.button[buttonLook].textColorHover;
  }, buttonLook, buttonLook, function (_ref2) {
    var theme = _ref2.theme;
    return theme.button[buttonLook].textColorActive;
  }, buttonLook, buttonLook, function (_ref3) {
    var theme = _ref3.theme;
    return theme.button[buttonLook].textColorFocus;
  }) : '';
  var disabledStroke = buttonLook ? css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        [aria-disabled='true'] & {\n          .bf-loader__svg-circle {\n            stroke: ", ";\n          }\n        }\n      "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.button[buttonLook].textColorDisabled;
  }) : '';
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n\n    .bf-loader__label {\n      color: ", ";\n    }\n  "])), stroke, disabledStroke, function (_ref5) {
    var theme = _ref5.theme;
    return theme.loader[look].textColor;
  });
};
/**
 * Get Styled Component stroke theme
 * @param options GetLoaderStrokeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getLoaderStroke = function getLoaderStroke(options) {
  return keyframes(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  0% {\n    stroke: ", ";\n  }\n  100% {\n    stroke: ", ";\n  }\n"])), options.theme.loader[options.look].strokeFromColor, options.theme.loader[options.look].strokeToColor);
};
var getLoaderRotate = function getLoaderRotate() {
  return keyframes(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
};
var getLoaderStretch = function getLoaderStretch() {
  return keyframes(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dashoffset: -124px;\n  }\n"])));
};
export { getLoaderPosition, getLoaderRotate, getLoaderSize, getLoaderStretch, getLoaderStroke, getLoaderTheme };